module.exports = __webpack_public_path__ + "img/partner_3.70a08238.png";